import { useState, useEffect } from 'react';

const usePriceStats = (propertyType: string) => {
    const [priceStats, setPriceStats] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!propertyType) {
            setLoading(false);
            return;
        }

        const fetchData = async () => {
            try {
                const response = await fetch('/api/stats/price?propertyType='+propertyType);
                const data = await response.json();
                setPriceStats(data);
                setLoading(false);
            } catch (error) {
                setError('Error fetching price stats');
                setLoading(false);
            }
        };

        fetchData();
    }, [propertyType]);

    return { priceStats, loading, error };
};

export default usePriceStats;